import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RappiderButtonModule } from '@rappider/rappider-components';


@Component({
  selector: 'rappider-diagram-node-toolbar',
  standalone: true,
  imports: [
    RappiderButtonModule

  ],
  templateUrl: './diagram-node-toolbar.component.html',
  styleUrls: ['./diagram-node-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagramNodeToolbarComponent { }
